import autoTable from 'jspdf-autotable';

import { generateFooter } from '../pdfFooter';
import { generateHeader } from '../pdfHeader';

import { GAP, TABLE_FONT_SIZE } from './constants';
import {
  didDrawCell,
  formatCells,
  generatePageNumberAndDate,
  getColumnStyles,
  splitRowsChunk,
  splitSmartChunks,
  updateFootPosition
} from './helpers';

export const generateTable = ({ doc, startY, columnHeaders, rows, totalsSum, configs = {} }) => {
  const edgeMargin = columnHeaders.length > 5 ? 0 : GAP;

  const columnChunks = splitSmartChunks(columnHeaders);
  const rowsChunk = splitRowsChunk({ doc, startY, rows });

  rowsChunk.forEach((chunkRows, chunkRowIndex) => {
    let rowsSlice = 0;

    // Add new page for each new row chunk (after the first)
    if (chunkRowIndex > 0) doc.addPage();

    columnChunks.forEach((headerChunk, columnChunkIndex) => {
      const tableRows = chunkRows.map((row) =>
        row.slice(rowsSlice, rowsSlice + headerChunk.length)
      );

      if (columnChunkIndex > 0) doc.addPage();

      const finalFoot =
        chunkRowIndex === rowsChunk.length - 1 &&
        columnChunkIndex === columnChunks.length - 1 &&
        updateFootPosition(totalsSum, headerChunk);

      autoTable(doc, {
        head: [headerChunk],
        body: tableRows,
        styles: { fontSize: TABLE_FONT_SIZE },
        foot: finalFoot,
        startY: chunkRowIndex === 0 && columnChunkIndex === 0 ? startY : 10,
        margin: { left: edgeMargin, right: edgeMargin },
        headStyles: { fillColor: '#004F6B', overflow: 'linebreak' },
        footStyles: { fontStyle: 'bold', align: 'right' },
        columnStyles: getColumnStyles(columnHeaders, rows),
        showFoot: totalsSum ? 'lastPage' : false,
        didParseCell: (data) => formatCells(data, finalFoot),
        didDrawCell,
        ...configs
      });

      rowsSlice += headerChunk.length;
    });
  });

  generatePageNumberAndDate(doc);

  const finalY = doc.lastAutoTable.finalY;
  return finalY;
};

//generate the complete table
export const generateCompleteTable = ({
  doc,
  columnHeaders,
  rows,
  totalsSum,
  headerConfigs = {},
  footerConfigs = {}
}) => {
  const startY = generateHeader({ doc, headerConfigs });

  const endY = generateTable({
    doc,
    startY,
    columnHeaders,
    rows,
    totalsSum
  });

  return generateFooter({ doc, endY, headerConfigs, footerConfigs });
};
